(ns io.daskul.webapp.config.subs
  "App config subscriptions."
  (:require
   [re-frame.core :as rf]))

;; Config loading state
(rf/reg-sub ::loading?
  (fn [db _]
    (get-in db [:config :loading?] false)))

;; Config loaded state
(rf/reg-sub ::loaded?
  (fn [db _]
    (get-in db [:config :loaded?] false)))

;; Config fetch error (the /_config call failed). Present = hard-required failure
;; → the boot gate shows Retry rather than spinning forever (SMS-70).
(rf/reg-sub ::error
  (fn [db _]
    (get-in db [:config :error])))

;; Full config data
(rf/reg-sub ::data
  (fn [db _]
    (get-in db [:config :data])))

;; App metadata
(rf/reg-sub ::app
  (fn [db _]
    (get-in db [:config :data :app])))

;; All aggregates config
(rf/reg-sub ::aggregates
  (fn [db _]
    (get-in db [:config :data :aggregates])))

;; Single aggregate config by key
(rf/reg-sub ::aggregate
  (fn [db [_ agg-key]]
    (get-in db [:config :data :aggregates agg-key])))

;; Aggregate keys (for navigation)
(rf/reg-sub ::aggregate-keys
  (fn [db _]
    (keys (get-in db [:config :data :aggregates]))))

;; URL resource to aggregate key mapping
;; e.g., "grade-levels" -> :grade-level
(rf/reg-sub ::resource->agg-key
  (fn [db _]
    (get-in db [:config :resource->agg-key])))

;; Get aggregate key for a URL resource
(rf/reg-sub ::agg-key-for-resource
  :<- [::resource->agg-key]
  (fn [resource-map [_ resource]]
    (get resource-map resource)))

;; Aggregate key to URL resource mapping
;; e.g., :person -> "persons"
(rf/reg-sub ::agg-key->resource
  (fn [db _]
    (get-in db [:config :agg-key->resource])))

;; Get URL resource for an aggregate key
(rf/reg-sub ::resource-for-agg-key
  :<- [::agg-key->resource]
  (fn [agg-map [_ agg-key]]
    (get agg-map agg-key)))
